import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IMeter } from '../../../utils/interfaces/meter';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class MeterReportService {
  private readonly URI_API = environment.apiConfig.uri + 'MeasurementReport';

  constructor(private readonly httpClient: HttpClient) {}

  getMeterReport(filter: IReportFilter): Observable<IResponse<IMeter>> {
    return this.httpClient.post<IResponse<IMeter>>(
      `${this.URI_API}/measurement`,
      filter
    );
  }
}
